import Vue from "vue";
import Vuex from "vuex";
import "es6-promise/auto";
import createPersistedState from "vuex-persistedstate";
import { get } from "lodash";

import mutations from "./mutations";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "simple-checklist"
    })
  ],
  state: {
    checklists: {},
    states: {}
  },
  mutations,
  getters: {
    isAccordionOpen: state => (checklistId, accordionId) =>
      get(state, ["checklists", checklistId, "accordions", accordionId], false),
    accordionState: state => (id, { merges = false }) => {
      if (!merges) {
        return get(state, ["states", id], "");
      }

      const entries = Object.entries(get(state, "states", {}));
      const entry = entries.find(
        entry => entry[0].split("/")[1] === id.split("/")[1]
      );

      return entry ? entry[1] : "";
    },
    checklistStates: state => checklistId => {
      const entries = Object.entries(get(state, ["states"], {}));
      const filteredEntries = entries.filter(entry =>
        entry[0].startsWith(checklistId)
      );

      return Object.fromEntries(filteredEntries);
    },
    checklistStatesByItemIds: state => ids => {
      const entries = Object.entries(get(state, ["states"], {}));
      let res = {};

      ids.forEach(id => {
        const filteredEntries = entries.filter(entry => entry[0].endsWith(id));
        res = { ...res, ...Object.fromEntries(filteredEntries) };
      });

      return res;
    }
  }
});

export default store;
